"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VoiceCode;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _imutils = require("@tencent/imutils");

var _CountDown = _interopRequireDefault(require("../../utils/CountDown"));

const TIMER_COUNT = 60;

function VoiceCode({
  onClick
}) {
  const _useState = (0, _react.useState)(false),
        _useState2 = (0, _slicedToArray2.default)(_useState, 2),
        isSending = _useState2[0],
        setIsSending = _useState2[1];

  let _useState3 = (0, _react.useState)(TIMER_COUNT),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      remainSec = _useState4[0],
      setRemainSec = _useState4[1];

  const countDown = (0, _react.useCallback)(() => {
    const countDownIns = new _CountDown.default({
      startSec: TIMER_COUNT,
      onCountChange: remainSec => {
        if (remainSec > 1) {
          setRemainSec(remainSec);
        } else {
          setIsSending(false);
        }
      }
    });

    if (isSending) {
      countDownIns.start();
    } else {
      countDownIns.clear();
    }
  }, []);
  const clickVoiceCode = (0, _react.useCallback)(async () => {
    if (isSending) return;

    _imutils.tdwReport.report({
      event: 'click',
      module: 'voice_verification'
    }); // 事件名


    try {
      // 正常发送触发。
      await onClick();
      setRemainSec(TIMER_COUNT);
      setIsSending(true);
      countDown();
    } catch (err) {
      console.log(err);
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "voice-code-comp"
  }, isSending ? /*#__PURE__*/_react.default.createElement("span", {
    className: "speech-timer"
  }, remainSec, "s\u540E\u91CD\u8BD5") : /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "get-speech-code-text"
  }, "\u6536\u4E0D\u5230\u77ED\u4FE1\u9A8C\u8BC1\u7801\uFF1F"), /*#__PURE__*/_react.default.createElement("span", {
    className: "get-speech-code-click",
    onClick: () => {
      (0, _imutils.throttle)(clickVoiceCode, 1000)();
    }
  }, "\u83B7\u53D6\u8BED\u97F3\u9A8C\u8BC1\u7801")));
}